import React, { useEffect, useState } from "react";
import MaintenanceItemInputs from "../../Inputs/MaintenanceItemInputs/MaintenanceItemInputs";
import { useNavigate, useParams } from "react-router-dom"; // Added useNavigate
import { useDispatch, useSelector } from "react-redux";
import {
  getStandardMaintenanceItemsById,
  updateStandardMaintenanceItem,
  deleteStandardMaintenanceItem, // Add this if you have it, or we'll need to create it
} from "../../../redux/StandardMaintenanceItemSlice/StandardMaintenanceItemSlice";
import notify from "../../../hooks/useNotifaction";
import Swal from "sweetalert2";
import { deleteMaintenanceItem } from "../../../redux/MaintenanceItemSlice/MaintenanceItemSlice";

export default function UpdateMaintenanceItem({ item }) {
  const [isParentElement, setIsParentElement] = useState(true);
  const [maintenanceItem, setMaintenanceItem] = useState(item || {});
  const [loading, setLoading] = useState(false); // Changed initial state to false
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { itemId } = useParams(); // Added to get ID from URL if needed
  const { status, error } = useSelector((state) => state.standardMaintenanceItems);

  // Sync item prop with state when it changes
  useEffect(() => {
    if (item) {
      setMaintenanceItem(item);
    }
  }, [item]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMaintenanceItem((prev) => ({ ...prev, [name]: value }));
  };

  const handleForm = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await dispatch(
        updateStandardMaintenanceItem({
          id: item.id || itemId,
          data: maintenanceItem,
        })
      ).unwrap();
      notify("تم التحديث بنجاح", "success");
    } catch (err) {
      notify(err?.message || "حدث خطأ أثناء التحديث", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (item) => {
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: "لن تتمكن من التراجع عن هذا الإجراء!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "نعم، احذف!",
      cancelButtonText: "إلغاء",
    });

    if (result.isConfirmed) {
      setLoading(true);
      try {
        await dispatch(deleteStandardMaintenanceItem(item.id)).unwrap();
        notify("تم الحذف بنجاح", "success");
        navigate("/MaintenanceItems");
      } catch (err) {
        notify(err?.message || "حدث خطأ أثناء الحذف", "error");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <form onSubmit={handleForm}>
      <div className="card mb-3 pt-5 pb-2 px-3 companyProfile">
        <MaintenanceItemInputs handleInputChange={handleInputChange} maintenanceItem={maintenanceItem} setMaintenanceItem={setMaintenanceItem} isParentElement={isParentElement} />
        <div className="d-flex justify-content-between mt-3">
          <button type="button" className="btn btn-danger" onClick={() => handleDelete(item)} disabled={loading}>
            {loading ? "جاري..." : "حذف"}
          </button>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? "جاري..." : "حفظ"}
          </button>
        </div>
      </div>
    </form>
  );
}
